import LegalPage, {
  proseLinkStyle,
  type LegalSection,
} from "@/components/landing/dcv2/LegalPage";

/**
 * Data-deletion instructions for data received from Facebook or Instagram.
 *
 * This is the URL entered as the Meta app's "User data deletion" instructions,
 * and Meta App Review reads it. Moving or renaming the route breaks that
 * setting, so change the app's settings first.
 *
 * The effective date is a literal for the same reason it is in Terms.tsx: a
 * computed date would silently reset to today on every page load. Edit this
 * string when the instructions change.
 */
const EFFECTIVE_DATE = "28 September 2026";

const SECTIONS: LegalSection[] = [
  {
    n: "1",
    title: "Disconnect in AI2Aim",
    blocks: [
      {
        p: "Go to Marketing → Platform Integration and disconnect the account. We stop using its access token immediately.",
      },
    ],
  },
  {
    n: "2",
    title: "Remove the app in Facebook",
    blocks: [
      {
        p: "Settings & privacy → Settings → Business integrations (or Apps and websites) → select AI2aim → Remove.",
      },
    ],
  },
  {
    n: "3",
    title: "Request deletion",
    blocks: [
      {
        p: (
          <>
            Email{" "}
            <a href="mailto:contact@ai2aim.ai" style={proseLinkStyle}>
              contact@ai2aim.ai
            </a>{" "}
            with the subject “Data deletion request” and the Facebook Page or
            account name. We delete the stored tokens, page data, insights and
            ad-spend records within 30 days and confirm by email.
          </>
        ),
      },
    ],
  },
];

export default function DataDeletion() {
  return (
    <LegalPage
      eyebrow="Legal"
      title="Deleting data we received from Facebook or Instagram"
      effectiveDate={EFFECTIVE_DATE}
      intro="If you connected a Facebook Page or Instagram account to AI2Aim, you can remove our access and your data at any time:"
      sections={SECTIONS}
    />
  );
}
